import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const values = [
    {
      icon: '🤝',
      title: 'Enfoque Colaborativo',
      description: 'Trabajamos codo a codo contigo, no como un proveedor externo sino como parte de tu equipo.'
    },
    {
      icon: '💎',
      title: 'Claridad y Transparencia',
      description: 'Comunicación directa, procesos claros y entregables que puedes entender y usar.'
    },
    {
      icon: '🎯',
      title: 'Entregables Accionables',
      description: 'Todo lo que creamos tiene un propósito claro y te ayuda a tomar decisiones concretas.'
    },
    {
      icon: '🧠',
      title: 'Más Estrategia que Horas',
      description: 'Priorizamos el impacto y la calidad del trabajo por encima del tiempo invertido.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <motion.div
            className="about-hero__content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="about-hero__title">
              Sobre <span className="gradient-text">DUIT</span>
            </h1>
            <p className="about-hero__subtitle">
              Somos una consultora de estrategia, diseño y arquitectura cloud que ayuda a emprendedores y empresas a convertir ideas en productos digitales listos para construir.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="about-mission">
        <div className="container">
          <div className="about-mission__grid">
            <motion.div
              className="about-mission__item"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="about-mission__icon">🎯</div>
              <h2 className="about-mission__title">Nuestra Misión</h2>
              <p className="about-mission__description">
                Ayudar a diseñar y construir productos digitales sólidos y escalables que realmente resuelvan problemas del mercado.
              </p>
            </motion.div>

            <motion.div
              className="about-mission__item"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="about-mission__icon">🚀</div>
              <h2 className="about-mission__title">Nuestra Visión</h2>
              <p className="about-mission__description">
                Ser la consultora líder de Product Discovery y diseño digital en LATAM, reconocida por convertir ideas en productos exitosos.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section className="about-values">
        <div className="container">
          <motion.div
            className="about-values__header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="about-values__title">Cómo Trabajamos</h2>
            <p className="about-values__description">
              Nuestros valores definen la forma en que abordamos cada proyecto y nos relacionamos con nuestros clientes.
            </p>
          </motion.div>

          <div className="about-values__grid">
            {values.map((value, index) => (
              <motion.div
                key={index}
                className="about-value-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="about-value-card__icon">{value.icon}</div>
                <h3 className="about-value-card__title">{value.title}</h3>
                <p className="about-value-card__description">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <motion.div
            className="about-cta__content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="about-cta__title">¿Quieres conocer más sobre nuestro enfoque?</h2>
            <p className="about-cta__description">
              Conversemos sobre tu proyecto y descubre cómo podemos ayudarte a convertir tu idea en un producto exitoso.
            </p>
            <div className="about-cta__actions">
              <Link to="/contact" className="btn btn--primary btn--large">
                Agenda una llamada
              </Link>
              <Link to="/services" className="btn btn--secondary btn--large">
                Ver nuestros servicios
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
